"use client";

import Link from "next/link";

interface BlogErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function BlogError({ error, reset }: BlogErrorProps) {
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center text-center">
      <h1 className="text-[length:var(--fs-3xl)] font-extrabold tracking-tight text-foreground">
        Something went wrong
      </h1>
      <p className="mt-4 max-w-md text-[length:var(--fs-base)] text-muted">
        We couldn&apos;t load the blog right now. This is usually temporary.
      </p>
      <div className="mt-8 flex items-center gap-4">
        <button
          onClick={reset}
          className="rounded-full bg-pink px-6 py-2.5 font-mono text-[length:var(--fs-sm)] font-bold text-white transition-colors hover:bg-pink-hover"
        >
          Try Again
        </button>
        <Link
          href="/"
          className="rounded-full border border-rule px-6 py-2.5 font-mono text-[length:var(--fs-sm)] font-bold text-muted transition-colors hover:border-pink/30"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
